import { BAR, FUNNEL, PIE } from "./types";

import defaultBarTooltipFormatter from "./Simple/echarts/BarChart/tooltipFormatter";
import defaultPieTooltipFormatter from "./Simple/echarts/PieChart/tooltipFormatter";
import defaultFunnelTooltipFormatter from "./Simple/echarts/FunnelChart/tooltipFormatter";

import { isNullOrEmptyArray } from "src/util/arrays";

// Estratégias de formatação default da tooltip para cada chart.
const defaultStrategies = {
  [BAR]: defaultBarTooltipFormatter,
  [PIE]: defaultPieTooltipFormatter,
  [FUNNEL]: defaultFunnelTooltipFormatter,
};

/**
 * Utiliza o formatador de tooltip padrão dado um gráfico e adiciona à ele as alternativas
 * consolidadas.
 * @param {object} echartParams Parâmetros de envio pelo proprio echarts.
 * @param {array} consolidations Array de objetos com cada consolidação
 * @param {function} defaultFormatter Formatador padrão da tooltip
 * @returns
 */
function getConsolidationTooltipFormatter(
  echartParams,
  consolidations = [],
  defaultFormatter
) {
  const { name } = echartParams;
  const currentConsolidationItem = consolidations.find(
    ({ enunciado }) => enunciado === name
  );

  let newParams = { ...echartParams };

  if (currentConsolidationItem) {
    const {
      alternativas_consolidadas,
    } = currentConsolidationItem;

    const labels = alternativas_consolidadas
      .map(
        ({ enunciado, resultado_numerico }) =>
          `${enunciado}: ${resultado_numerico} respostas<br/>`
      )
      .join("");
    
    const marker = `<br/><br/><strong>Alternativas consolidadas</strong><br/>${labels}`;
    console.log(labels, '@@')
    newParams.optionalContent = marker;
  }

  return defaultFormatter(newParams);
}

/**
 * Recupera o formatter de um gráfico, levando em conta suas consolidações.
 * @param {array | object} data Resultados obtidos para um gráfico, o utilizamos para identificar suas possíveis consolidações.
 * @param {string} chartType Tipo do gráfico BAR | PIE | FUNNEL | ...
 * @returns {function} Formatador de tooltip padrão do gráfico ou o formatter que considera as alternativas consolidadas.
 */
export default function getTooltipFormatter(data, chartType) {
  const consolidations = data.filter((item) => item.consolidacao);
  const defaultFormatter = defaultStrategies[chartType];

  // Caso não existam consolidações, retornamos o formatador padrão.
  if (isNullOrEmptyArray(consolidations)) {
    return defaultFormatter;
  }

  // Recuperamos o formatador para alternativas consolidadas.
  return function(params) {
    return getConsolidationTooltipFormatter(
      params,
      consolidations,
      defaultFormatter
    );
  };
}
